import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { default as CancelIcon, default as CloseIcon } from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import "./Index.css";
import dayjs from "dayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import {
  Avatar,
  Badge,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
  GridToolbarContainer
} from "@mui/x-data-grid";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import { MuiFileInput } from "mui-file-input";
import workoutDefaultVideo from "../../assets/videos/workout/220150_medium.mp4";
import recipeDefaultImage from "../../assets/images/recipelogo/r2.jpg";
import uploadFileImage from "../../assets/images/logos/image.png";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

const EquipmentsDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            {details.map((equipment, index) => (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img src={`${equipment.icon}`} height="25" width="25" />
                <Typography key={index} component="div">
                  {equipment.name}
                </Typography>
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const userType = 2;
const appColor = "#59D6DF";
const initialRows = [];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  maxHeight: "90vh",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
  overflowX: "hidden"
};

const secondToMMSS = (given_seconds) => {
  const dateObj = new Date(given_seconds * 1000);
  const minutes = dateObj.getUTCMinutes();
  const seconds = dateObj.getSeconds();

  const timeString =
    minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
  return timeString;
};

function EditToolbar(props) {
  const {
    setRows,
    setRowModesModel,
    addedUser,
    setAddedUser,
    showToolbar,
    setShowToolbar,
    selectExercise,
    setSelectExercise
  } = props;
  const [open, setOpen] = React.useState(false);
  const [id, setId] = useState("");
  const [image, setImage] = useState("");
  const [videoPreview, setVideoPreview] = useState("");
  const [name, setName] = useState("");
  const [sets, setSets] = useState("");
  const [reps, setReps] = useState("");
  const [time, setTime] = useState(0);
  const [rest, setRest] = useState(0);
  const [idealTime, setIdealTime] = useState(0);
  const [workoutType, setWorkoutType] = useState("");
  const [exerciseInputType, setExerciseInputType] = useState(""); // "reps" or "time"
  const [defaultRest, setDefaultRest] = useState(dayjs("00:00", "mm:ss"));
  const [defaultIdealTime, setDefaultIdealTime] = useState(dayjs("00:00", "mm:ss"));
  const [defaultTime, setDefaultTime] = useState(dayjs("00:00", "mm:ss"));
  const [previews, setPreviews] = useState({});
  const [equipments, setEquipments] = useState([{ name: "", icon: null, _id: null }]);
  const [deletedEquipmentIds, setDeletedEquipmentIds] = useState([]);
  const [nameError, setNameError] = useState("");
  const [setsError, setSetsError] = useState("");
  const [repsError, setRepsError] = useState("");
  const [timeError, setTimeError] = useState("");
  const [restTimeError, setRestTimeError] = useState("");
  const [idealTimeError, setIdealTimeError] = useState("");
  const [workoutTypeError, setWorkoutTypeError] = useState("");
  const [equipmentsError, setEquipmentsError] = useState("");
  const [imageError, setImageError] = useState("");
  const [exerciseInputTypeError, setExerciseInputTypeError] = useState("");
  const [loading, setLoading] = useState(false);

  function getPosition(string, subString, index) {
    if (typeof string !== "string") return;
    return string.split(subString, index).join(subString).length;
  }
  const linkStart = getPosition(selectExercise?.image, "h", 4);
  const linkEnd = getPosition(selectExercise?.image, '"', 6);
  let link = "";
  if (linkStart && linkEnd) {
    for (let index = linkStart; index < linkEnd; index++) {
      link += selectExercise?.image[index];
    }
  }
  const type = [
    {
      value: 1,
      label: "Warm Up"
    },
    {
      value: 2,
      label: "Workout"
    }
  ];
  const handleEquipmentChange = (index, event) => {
    const { name, value } = event.target;
    const updatedEquipments = [...equipments];
    updatedEquipments[index][name] = value;
    setEquipments(updatedEquipments);
  };

  const countSeconds = (date) => {
    return dayjs(date).minute() * 60 + dayjs(date).second();
  };

  const addEquipments = () => {
    setEquipments([...equipments, { name: "", icon: null, _id: null }]);
  };

  const removeEquipment = (index) => {
    const equipment = equipments[index];
    if (equipment._id) {
      setDeletedEquipmentIds((prev) => [...prev, equipment._id]);
    }
    setEquipments(equipments.filter((_, i) => i !== index));
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setRest(0);
    setIdealTime(0);
    setTime(0);
    setWorkoutType("");
    setExerciseInputType("");
    setEquipments([{ name: "", icon: null }]);
    setShowToolbar(false);
    setSelectExercise({});
    setDefaultRest(dayjs("00:00", "mm:ss"));
    setDefaultIdealTime(dayjs("00:00", "mm:ss"));
    setDefaultTime(dayjs("00:00", "mm:ss"));
    setImage("");
    setVideoPreview("");
    setNameError("");
    setSetsError("");
    setRepsError("");
    setTimeError("");
    setImageError("");
    setRestTimeError("");
    setIdealTimeError("");
    setWorkoutTypeError("");
    setExerciseInputTypeError("");
    setEquipments([{ name: "", icon: null }]);
    setEquipmentsError("");
    setDeletedEquipmentIds([]);
    setLoading(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file, "file");
    if (event.target.files[0].type == "video/mp4") {
      setImage(file);
      setVideoPreview(URL.createObjectURL(file));
      setImageError("");
    } else {
      setImageError("Please upload valid mp4 video");
    }
  };

  const handleEquipmentFileChange = (index, file) => {
    const newEquipments = [...equipments];
    newEquipments[index].icon = file;

    if (file) {
      const objectUrl = URL.createObjectURL(file);
      newEquipments[index].preview = objectUrl;
    } else {
      newEquipments[index].preview = null;
    }

    setEquipments(newEquipments);
  };

  function MStoSeconds(ms) {
    const [minutes, seconds] = ms.split(":");
    const totalSeconds = +minutes * 60 + +seconds;
    return totalSeconds;
  }

  useEffect(() => {
    if (Object.keys(selectExercise).length) {
      setId(selectExercise.id || "");
      setImage(selectExercise.image ? link : "");
      setName(selectExercise.name);
      setSets(+selectExercise.sets);
      setReps(selectExercise.reps ? +selectExercise.reps : "");
      // Handle time: could be number (seconds) or string (mm:ss)
      let timeValue = 0;
      if (selectExercise.time) {
        if (typeof selectExercise.time === "number") {
          timeValue = selectExercise.time;
        } else if (typeof selectExercise.time === "string" && selectExercise.time.includes(":")) {
          timeValue = MStoSeconds(selectExercise.time);
        }
      }
      setTime(timeValue);

      // Set exercise input type based on existing data
      if (selectExercise.reps && selectExercise.reps !== null && selectExercise.reps !== "") {
        setExerciseInputType("reps");
      } else if (timeValue > 0) {
        setExerciseInputType("time");
      }
      setRest(MStoSeconds(selectExercise.rest));
      setIdealTime(MStoSeconds(selectExercise.idealTime));
      setWorkoutType(selectExercise.type.trim());
      setVideoPreview(link);
      if (Array.isArray(selectExercise.equipments) && selectExercise.equipments.length) {
        const mappedEquip = selectExercise.equipments.map((value) => {
          return {
            name: value.name,
            icon: null, // Reset for file selection
            preview: value.icon ? `${value.icon}` : null,
            _id: value._id
          };
        });
        setEquipments(mappedEquip);
      }
      setDefaultRest(dayjs(`${selectExercise.rest}`, "mm:ss"));
      setDefaultIdealTime(dayjs(`${selectExercise.idealTime.trim()}`, "mm:ss"));
      setDefaultTime(timeValue ? dayjs(`${secondToMMSS(timeValue)}`, "mm:ss") : dayjs("00:00", "mm:ss"));
    } else {
      setId("");
      setImage("");
      setName("");
      setSets("");
      setReps("");
      setTime(0);
      setRest(0);
      setIdealTime(0);
      setVideoPreview(workoutDefaultVideo);
      setWorkoutType("");
      setExerciseInputType("");
      setDefaultRest(dayjs("00:00", "mm:ss"));
      setDefaultIdealTime(dayjs("00:00", "mm:ss"));
      setDefaultTime(dayjs("00:00", "mm:ss"));
      setEquipments([{ name: "", icon: null, preview: null }]);
    }
    setOpen(showToolbar);
  }, [showToolbar, addedUser]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof image == "string" && image.trim() == "") {
      setImageError("Workout image is required");
      return;
    }
    if (name.trim() == "") {
      setNameError("Workout name is required");
      return;
    }
    if (!sets || sets == "") {
      setSetsError("Number of sets are required");
      return;
    }

    if (!exerciseInputType) {
      setExerciseInputTypeError("Please select exercise input type");
      return;
    }

    // Validation based on selected input type
    if (exerciseInputType === "reps") {
      if (!reps || reps === "" || reps === "0") {
        setRepsError("Number of repetitions are required");
        return;
      }
    } else if (exerciseInputType === "time") {
      if (!time || time === 0) {
        setTimeError("Time is required");
        return;
      }
    }

    if (!idealTime) {
      setIdealTimeError("Ideal time is required!");
      return;
    }

    if (workoutType == "") {
      setWorkoutTypeError("Workout Type is required");
      return;
    }

    if (
      equipments.some(
        (eqp) => (!eqp.name && eqp.icon && eqp.preview) || (eqp.name && !eqp.icon && !eqp.preview)
      )
    ) {
      setEquipmentsError("All fields in Equipments are required.");
      return;
    } else {
      setEquipmentsError("");
    }
    const updatedEquipments = equipments.filter((value) => {
      // If a new file is added (icon is a File object) OR if it's a new equipment (no _id)
      return value.icon instanceof File || !value._id;
    });

    // Extract only the updated/new equipment details
    const equimentImage = updatedEquipments.map((value) => {
      delete value.preview;
      return value.icon; // Can be null or a file object
    });

    console.log(equimentImage, "equimentImage");

    const equimentName = updatedEquipments.map((value) => {
      delete value.preview;
      return value.name;
    });

    const equimentId = updatedEquipments.map((value) => {
      delete value.preview;
      return value._id || null; // Send null for new equipment
    });
    const formData = new FormData();
    formData.append("id", id);
    formData.append("gif", image);
    formData.append("name", name);
    formData.append("sets", sets);
    formData.append("reps", exerciseInputType === "reps" ? reps : "");
    formData.append("time", exerciseInputType === "time" ? time : "");
    formData.append("rest", rest);
    formData.append("idealTime", idealTime);
    formData.append("workoutType", workoutType);
    equimentName.forEach((name) => {
      formData.append("equimentName", name);
    });

    equimentImage.forEach((img) => {
      formData.append("equimentImage", img);
    });

    equimentId.forEach((_id) => {
      formData.append("equipmentId", _id);
    });

    deletedEquipmentIds.forEach((id) => {
      formData.append("deletedEquipmentIds", id);
    });

    const headers = {
      "Content-Type": "multipart/form-data",
      "x-access-token": `${localStorage.getItem("token")}`
    };

    setLoading(true);
    axios
      .post(`${apiBaseURL}/api/v1/admin/addupdateworkout`, formData, {
        headers: headers
      })
      .then((res) => {
        if (res.data) {
          setOpen(false);
          setShowToolbar(false);
          setAddedUser(!addedUser);
          setVideoPreview("");
          setSelectExercise({});
          setImageError("");
          setDeletedEquipmentIds([]);
          const { message } = res.data;
          Swal.fire({
            position: "center",
            icon: "success",
            title: `${message}`,
            showConfirmButton: false,
            timer: 1000
          });
        }
      })
      .catch((error) => {
        console.log(error, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`
  }));

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Button
        sx={{ color: "#59D6DF", border: "1px solid grey" }}
        startIcon={<AddIcon />}
        onClick={handleOpen}
      >
        Add Exercise
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Box mb={2}>
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  onClick={() => document.getElementById("videoInput").click()}
                  badgeContent={<SmallAvatar alt="Upload Video" src={uploadFileImage} />}
                >
                  <video
                    width="150"
                    height="150"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 5px 10px 0px #163F7533"
                    }}
                    controls
                    controlslist="nodownload"
                    src={videoPreview}
                  />
                  <VisuallyHiddenInput
                    id="videoInput"
                    name="video"
                    type="file"
                    accept="video/*"
                    onChange={handleFileChange}
                  />
                </Badge>
                <InputLabel sx={{ pt: 1, color: "red" }}>{imageError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Exercise Name"
                  name="name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value), setNameError("");
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{nameError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Sets(In digits only)"
                  name="sets"
                  type="number"
                  value={sets}
                  onChange={(event) => {
                    setSets(event.target.value);
                    setSetsError("");
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{setsError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="exercise-input-type-label">Exercise Input Type</InputLabel>
                  <Select
                    labelId="exercise-input-type-label"
                    fullWidth
                    value={exerciseInputType}
                    onChange={(event) => {
                      const selectedType = event.target.value;
                      setExerciseInputType(selectedType);
                      setExerciseInputTypeError("");

                      // Clear the other field when type changes
                      if (selectedType === "reps") {
                        setTime(0);
                        setDefaultTime(dayjs("00:00", "mm:ss"));
                        setTimeError("");
                      } else if (selectedType === "time") {
                        setReps("");
                        setRepsError("");
                      }
                    }}
                    label="Exercise Input Type"
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                  >
                    <MenuItem value="reps">Repetitions Based</MenuItem>
                    <MenuItem value="time">Time Based</MenuItem>
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{exerciseInputTypeError}</InputLabel>
              </Box>
              {exerciseInputType === "reps" && (
                <Box mb={2}>
                  <TextField
                    fullWidth
                    label="Repetitions(In digits only)"
                    type="number"
                    name="fullName"
                    value={reps}
                    onChange={(event) => {
                      setReps(event.target.value);
                      setRepsError("");
                    }}
                  />
                  <InputLabel sx={{ pt: 1, color: "red" }}>{repsError}</InputLabel>
                </Box>
              )}
              {exerciseInputType === "time" && (
                <Box mb={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimeField"]}>
                      <TimeField
                        label="Time(In mm:ss format)"
                        format="mm:ss"
                        error={false}
                        defaultValue={defaultTime}
                        onChange={(newValue) => {
                          if (newValue && dayjs.isDayjs(newValue)) {
                            const seconds = countSeconds(newValue);
                            setTime(seconds);
                            setTimeError("");
                          }
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <InputLabel sx={{ pt: 1, color: "red" }}>{timeError}</InputLabel>
                </Box>
              )}
              <Box mb={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["TimeField"]}>
                    <TimeField
                      label="Rest Time"
                      format="mm:ss"
                      error={false}
                      defaultValue={defaultRest}
                      onChange={(newValue) => {
                        if (newValue && dayjs.isDayjs(newValue)) {
                          const seconds = countSeconds(newValue);
                          setRest(seconds);
                        }
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <InputLabel sx={{ pt: 1, color: "red" }}>{restTimeError}</InputLabel>
              </Box>
              <Box mb={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["TimeField", "TimeField", "TimeField"]}>
                    <TimeField
                      label="Ideal Time"
                      format="mm:ss"
                      error={false}
                      defaultValue={defaultIdealTime}
                      onChange={(newValue) => {
                        if (newValue && dayjs.isDayjs(newValue)) {
                          const seconds = countSeconds(newValue);
                          setIdealTime(seconds);
                        }
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <InputLabel sx={{ pt: 1, color: "red" }}>{idealTimeError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Exercise Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    fullWidth
                    value={workoutType}
                    onChange={(event) => {
                      setWorkoutType(event.target.value);
                    }}
                    defaultValue={workoutType}
                    label="Workout Type"
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                  >
                    {type.map((option) => (
                      <MenuItem sx={{ height: "45px" }} key={option.value} value={option.label}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{workoutTypeError}</InputLabel>
              </Box>
              <Box mb={2}>
                <Box sx={{ maxHeight: "12vh", overflowY: "auto" }}>
                  <Typography variant="h6">Equipments</Typography>
                  {equipments.map((equipment, index) => (
                    <Box display="flex" gap={1} mb={1} key={index} alignItems="center">
                      <TextField
                        label="Name"
                        name="name"
                        value={equipment.name}
                        onChange={(event) => handleEquipmentChange(index, event)}
                        fullWidth
                      />
                      <MuiFileInput
                        placeholder="Insert icon"
                        value={equipment.icon}
                        onChange={(file) => handleEquipmentFileChange(index, file)}
                      />
                      <IconButton
                        onClick={() => removeEquipment(index)}
                        color="error"
                      >
                        <DeleteIcon />
                      </IconButton>
                      {(equipment.preview || previews[index]) && (
                        <img
                          src={equipment.preview || previews[index]}
                          alt="preview"
                          style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 8, flexShrink: 0 }}
                        />
                      )}
                    </Box>
                  ))}
                </Box>
                <Box mt={2}>
                  <Button onClick={addEquipments} variant="contained" sx={{ color: "#FFFFFF" }}>
                    Add More Equipments
                  </Button>
                </Box>
                <InputLabel sx={{ pt: 1, color: "red" }}>{equipmentsError}</InputLabel>
              </Box>
              <Box mt={4} mb={1}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={loading}
                  sx={{
                    backgroundColor: appColor,
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: appColor
                    }
                  }}
                  fullWidth
                >
                  {loading ? (
                    <>
                      <CircularProgress size={20} sx={{ color: "white", mr: 1 }} />
                      Registering...
                    </>
                  ) : Object.keys(selectExercise).length ? (
                    "Update Workout"
                  ) : (
                    "Register Workout"
                  )}
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </GridToolbarContainer>
  );
}

const Workouts = () => {
  const [rows, setRows] = React.useState(initialRows);
  const [addedUser, setAddedUser] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [calledBlockUser, setCallBlockUser] = useState(false);
  const [profilePic, setProfilePic] = React.useState({});
  const [calledUpdateUser, setCallUpdateUser] = useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [debouncedSearchBy, setDebouncedSearchBy] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEquipmentsDetails, setSelectedEquipmentsDetails] = useState(null);
  const [selectExercise, setSelectExercise] = useState({});
  const [showToolbar, setShowToolbar] = React.useState(false);

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchBy(searchBy);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchBy]);

  // Reset pagination when search changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchBy]);

  const handleOpenModal = (details) => {
    setSelectedEquipmentsDetails(details);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEquipmentsDetails(null);
    setModalOpen(false);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };
        const exerciseList = await axios.post(
          `${apiBaseURL}/api/v1/admin/getexercises`,
          {
            searchBy: debouncedSearchBy,
            page: paginationModel.page + 1, // API expects 1-based page numbers
            pageSize: paginationModel.pageSize
          },
          {
            headers: headers
          }
        );
        if (exerciseList.data) {
          const { exercises, total, currentPage, totalPages } = exerciseList.data.data;
          const currentRows = exercises.map((value, index) => {
            return {
              id: value?._id,
              image: value?.gif
                ? `<iframe height="50" width="50"
src="${value?.gif}"></iframe>`
                : `<img src="${apiBaseURL}/img/Profile.svg" height="50"> `,
              name: `${value?.name} `,
              sets: `${value?.sets} `,
              reps: value?.reps ? `${value?.reps} ` : "",
              time: value?.time && value?.time !== null ? secondToMMSS(value?.time) : "",
              rest: value?.rest ? secondToMMSS(value?.rest) : "00:00",
              idealTime: value?.idealTime ? secondToMMSS(value?.idealTime) : "00:00",
              type: `${value?.type} `,
              equipments: value?.equipments?.length ? value?.equipments : null
            };
          });
          setRows(currentRows);
          setTotalRows(total || exercises.length);
        }
      } catch (error) {
        console.error("Error fetching exercises:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch exercises. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [
    addedUser,
    calledBlockUser,
    calledUpdateUser,
    debouncedSearchBy,
    paginationModel.page,
    paginationModel.pageSize
  ]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete this exercise?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: appColor
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const headers = {
              "Content-Type": "application/json",
              "x-access-token": `${localStorage.getItem("token")}`
            };
            const deleteWorkout = await axios.delete(`${apiBaseURL}/api/v1/admin/deleteworkout`, {
              headers: headers,
              data: {
                id
              }
            });
            if (deleteWorkout.data) {
              Swal.fire("The exercise is deleted now!", "", "success");
              setRows(rows.filter((row) => row.id !== id));
            }
          } catch (error) {
            console.log(error, "error");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleFileChange = (e, params) => {
    const file = e.target.files[0];
    if (file) {
      const updatedRow = {
        ...params.row,
        // profilePic: `<img src="${URL.createObjectURL(file)}" />`,?
        profilePic: file
      };
      setProfilePic(updatedRow.profilePic);
      setRows((prevRows) => prevRows.map((row) => (row.id === params.id ? updatedRow : row)));
    }
  };

  const columns = [
    {
      field: "image",
      headerName: "Exercise Video",
      width: 150,
      type: "file",
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: params.value // Render the HTML content (image tag)
            }}
          />
        );
      },
      renderEditCell: (params) => {
        return (
          <Box>
            <VisuallyHiddenInput
              id="picture"
              name="picture"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, params)}
            />
            <IconButton
              aria-label="upload"
              sx={{
                border: "1px solid #F2F2F2",
                borderRadius: 2
              }}
              onClick={() => document.getElementById("picture").click()}
            >
              <img height="20" width="20" src={uploadFileImage} alt="upload icon" />
            </IconButton>
          </Box>
        );
      }
    },
    { field: "name", headerName: "Exercise Name", width: 150, sortable: false },
    {
      field: "sets",
      headerName: "Sets",
      type: "number",
      width: 150,
      sortable: false
    },
    {
      field: "reps",
      headerName: "Repetitions",
      width: 150,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        return params.value && params.value.trim() !== "" ? params.value : "-";
      }
    },
    {
      field: "time",
      headerName: "Time",
      width: 150,
      type: "string",
      sortable: false,
      renderCell: (params) => {
        return params.value && params.value.trim() !== "" ? params.value : "-";
      }
    },
    {
      field: "rest",
      headerName: "Rest Time",
      width: 150,
      type: "string",
      sortable: false
    },
    {
      field: "idealTime",
      headerName: "Ideal Time",
      width: 150,
      type: "string",
      sortable: false
    },
    {
      field: "type",
      headerName: "Type(Workout/Warm Up)",
      width: 150,
      type: "string",
      sortable: false
    },
    {
      field: "equipments",
      headerName: "Equipments",
      sortable: false,
      width: 150,
      renderCell: (params) =>
        params.row.equipments ? (
          <IconButton sx={{ left: -30 }} onClick={() => handleOpenModal(params.row.equipments)}>
            <Button href="#text-buttons" style={{ textTransform: "none" }}>
              View Equipments
            </Button>
          </IconButton>
        ) : (
          "N/A"
        )
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      cellClassName: "actions",
      getActions: (params) => {
        const id = params.row.id;
        // const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        // if (isInEditMode) {
        //   return [
        //     <GridActionsCellItem
        //       icon={<SaveIcon />}
        //       label="Save"
        //       sx={{
        //         color: "primary.main"
        //       }}
        //       onClick={() => {
        //         handleSaveClick(id);
        //       }}
        //     />,
        //     <GridActionsCellItem
        //       icon={<CancelIcon />}
        //       label="Cancel"
        //       className="textPrimary"
        //       onClick={() => {
        //         handleCancelClick(id);
        //       }}
        //       color="inherit"
        //     />
        //   ];
        // }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
              setShowToolbar(true);
              setSelectExercise(params.row);
            }}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => {
              handleDeleteClick(id);
            }}
            color="inherit"
          />
        ];
      }
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <TextField
          id="outlined-basic"
          label="Search by Exercise Name"
          variant="outlined"
          value={searchBy}
          onChange={(event) => {
            setSearchBy(event.target.value);
          }}
          sx={{
            width: "300px"
          }}
        />
      </Box>
      <Box
        sx={{
          height: 675,
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          slots={{
            toolbar: EditToolbar
          }}
          // Server-side pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-row:focus": {
              outline: "none"
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none"
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
          localeText={{ noRowsLabel: "No Workout is available" }}
          slotProps={{
            toolbar: {
              setRows,
              setRowModesModel,
              addedUser,
              setAddedUser,
              showToolbar,
              setShowToolbar,
              selectExercise,
              setSelectExercise
            }
          }}
        />
        <EquipmentsDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          details={selectedEquipmentsDetails}
        />
      </Box>
    </DashboardLayout>
  );
};

export default Workouts;
